import axios from '@/api'

/**
 * 省市区街道选择
 * @param {params} params
 * @returns {Promise<AxiosResponse<areasResult>>}
 */
export const fetchAreas = (code) => {
  return axios.get(`/cfg/districts?code=${code}`)
}
